/**
 * Description: YouTube Video Player (EN/ES)
 * Author: Global IID
 * Version: 1.0.0
 * License: GNU General Public License v2 or later
 * License URI: http://www.gnu.org/licenses/gpl-2.0.html
 *
 * Chapter buttons (data-videoname, data-videotime, data-lang) jump a player to a time,
 * swapping to the other language's video first if needed. Each player tracks its own
 * language. Video ids come from PHP as ssYoutubeVideo.
 */

// The videos from PHP, like { IID: { elId: '...', en: 'abc', es: 'xyz' } }.
var ssVideoList = {};

if (window.ssYoutubeVideo && window.ssYoutubeVideo.videos) {
  ssVideoList = window.ssYoutubeVideo.videos;
}

// One entry per player we build: { player: ..., language: 'en', isReady: false }.
var ssPlayers = {};

// A chapter clicked before we could play it. We keep the newest one and run it later.
var ssPendingChapter = null;

// OneTrust's cookie group for videos.
var SS_VIDEO_COOKIE_GROUP = 'C0004';

/**
 * 1. Ask YouTube for its player code.
 *
 * OneTrust blocks this script until the visitor accepts video cookies, then loads it
 * for us. So it is normal for nothing to happen here until they accept.
 */
function ssLoadYouTubeApi() {
  // Only skip if OUR tag is already there. OneTrust adds its own copy of this script
  // and that one can sit pending forever, so we must not treat it as ours - otherwise
  // we wait for an API that never loads and the video never appears.
  if (document.getElementById('ss-youtube-api')) {
    return;
  }

  var tag = document.createElement('script');
  tag.id = 'ss-youtube-api';
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);
}

/**
 * 2. Build a player for every video that has a container on this page.
 */
function ssCreatePlayers() {
  for (var key in ssVideoList) {
    if (ssPlayers[key]) {
      continue; // Already built.
    }

    if (!document.getElementById(ssVideoList[key].elId)) {
      continue; // This video is not on this page.
    }

    ssCreateOnePlayer(key);
  }
}

/**
 * Builds one player. Kept separate so each player's onReady remembers its own key.
 *
 * @param {string} key Video key, such as 'IID'.
 */
function ssCreateOnePlayer(key) {
  var video = ssVideoList[key];

  ssPlayers[key] = {
    player: null,
    language: 'en',
    isReady: false
  };

  ssPlayers[key].player = new YT.Player(video.elId, {
    // The size comes from the CSS so the player can be responsive.
    width: '100%',
    height: '100%',
    videoId: video.en,
    playerVars: {
      rel: 0,
      playsinline: 1,
      iv_load_policy: 3,
      enablejsapi: 1
    },
    events: {
      onReady: function () {
        ssPlayers[key].isReady = true;
        ssRunPendingChapter();
      }
    }
  });
}

/**
 * 3. Jump a video to a chapter, changing language first if we need to.
 *
 * @param {string} key      Video key, such as 'IID'.
 * @param {number} seconds  Where to start.
 * @param {string} language 'en' or 'es'.
 */
function ssPlayChapter(key, seconds, language) {
  var video = ssVideoList[key];

  if (!video) {
    return;
  }

  // No cookie consent yet, so YouTube has not loaded. Remember what they wanted and
  // open the cookie settings so they know why nothing played.
  if (!ssHasVideoConsent()) {
    ssPendingChapter = { key: key, seconds: seconds, language: language };
    ssOpenCookieSettings();
    return;
  }

  // Player is not built or not ready yet. Remember it and play once it is.
  if (!ssPlayers[key] || !ssPlayers[key].isReady) {
    ssPendingChapter = { key: key, seconds: seconds, language: language };
    return;
  }

  var entry = ssPlayers[key];

  // Different language, so load that language's video starting at the chapter.
  if (language && language !== entry.language && video[language]) {
    entry.player.loadVideoById({ videoId: video[language], startSeconds: seconds });
    entry.language = language;
    return;
  }

  // Same language, or no video in the language they asked for (FLEX and BC have no
  // Spanish version), so just move the current video to the chapter.
  entry.player.seekTo(seconds, true);
  entry.player.playVideo();
}

/**
 * 4. Play a chapter that was clicked earlier, now that the player can handle it.
 */
function ssRunPendingChapter() {
  if (!ssPendingChapter) {
    return;
  }

  var chapter = ssPendingChapter;

  if (!ssPlayers[chapter.key] || !ssPlayers[chapter.key].isReady) {
    return; // Still not ready, so keep waiting.
  }

  ssPendingChapter = null;
  ssPlayChapter(chapter.key, chapter.seconds, chapter.language);
}

/**
 * 5. Has the visitor allowed video cookies?
 *
 * If OneTrust is not on the page there is nothing to check, so we allow it.
 *
 * @return {boolean}
 */
function ssHasVideoConsent() {
  if (typeof window.OnetrustActiveGroups !== 'string' || window.OnetrustActiveGroups === '') {
    return true;
  }

  return window.OnetrustActiveGroups.indexOf(SS_VIDEO_COOKIE_GROUP) !== -1;
}

/**
 * Opens the OneTrust cookie settings panel.
 */
function ssOpenCookieSettings() {
  if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
    window.OneTrust.ToggleInfoDisplay();
  }
}

/**
 * 6. Highlight the chapter that was clicked, in its own list only.
 *
 * @param {Element} button The chapter button.
 */
function ssHighlightChapter(button) {
  var list = button.closest('.ss-video-chapters');

  if (!list) {
    return;
  }

  var buttons = list.querySelectorAll('.ss-video-chapters__link');

  for (var i = 0; i < buttons.length; i++) {
    buttons[i].classList.remove('is-active');
  }

  button.classList.add('is-active');
}

/**
 * 7. What happens when a chapter is clicked.
 *
 * @param {Event} event The click.
 */
function ssOnChapterClick(event) {
  var button = this;
  var key = button.getAttribute('data-videoname');

  // Not one of our videos, or its player is not on this page, so leave it alone.
  if (!ssVideoList[key] || !document.getElementById(ssVideoList[key].elId)) {
    return;
  }

  event.preventDefault();

  var seconds = parseFloat(button.getAttribute('data-videotime'));

  if (isNaN(seconds)) {
    seconds = 0;
  }

  ssHighlightChapter(button);
  ssPlayChapter(key, seconds, button.getAttribute('data-lang'));
}

function ssParseRgb(color) {
  var match = color && color.match(/rgba?\(([^)]+)\)/);

  if (!match) {
    return null;
  }

  var parts = match[1].split(',').map(function (part) {
    return parseFloat(part);
  });

  if (parts.length === 4 && parts[3] === 0) {
    return null; // Fully transparent.
  }

  return [parts[0], parts[1], parts[2]];
}

// Most elements are transparent, so walk up until something actually sets a background.
function ssFindBackgroundColor(el) {
  var node = el;

  while (node) {
    var rgb = ssParseRgb(getComputedStyle(node).backgroundColor);

    if (rgb) {
      return rgb;
    }

    node = node.parentElement;
  }

  return [255, 255, 255];
}

function ssMatchChapterColorsToBackground() {
  var lists = document.querySelectorAll('.ss-video-chapters');

  for (var i = 0; i < lists.length; i++) {
    var rgb = ssFindBackgroundColor(lists[i]);
    var luminance = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];

    lists[i].classList.toggle('ss-video-chapters--on-dark', luminance < 140);
  }
}

/**
 * 8. Start everything.
 */
function ssStartVideoPlayers() {
  // Listen to every chapter button on the page.
  var buttons = document.querySelectorAll('[data-videoname]');

  for (var i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', ssOnChapterClick);
  }

  ssMatchChapterColorsToBackground();

  ssLoadYouTubeApi();

  // Keep checking until YouTube's code turns up, then build the players and stop
  // checking. We do not give up after a few seconds because the visitor might accept
  // cookies much later, and that is when OneTrust finally lets the code load.
  var waitForYouTube = setInterval(function () {
    if (window.YT && window.YT.Player) {
      clearInterval(waitForYouTube);
      ssCreatePlayers();
    }
  }, 250);
}

if (document.readyState === 'loading') {
  window.addEventListener('DOMContentLoaded', ssStartVideoPlayers);
} else {
  ssStartVideoPlayers();
}
